import React from 'react';
import { useTranslation } from 'react-i18next';

import { useAnalyticsFilters } from '../../../contexts/AnalyticsFiltersContext';
import { SelectCustomizable } from '../../atoms/legacyAtoms';
import './_analytics-filter-bar.scss';

/**
 * AnalyticsFilterBar - Shared filter dropdowns for analytics pages.
 * Consumes filter state from AnalyticsFiltersContext.
 */
function AnalyticsFilterBar(): JSX.Element {
  const { t } = useTranslation(['chatbot']);
  const { classOptions, selectedClass, selectedTimePeriod, setSelectedClass, setSelectedTimePeriod, timePeriodOptions } = useAnalyticsFilters();

  return (
    <div className="analytics-filter-bar">
      <div className="analytics-filter-bar__filter">
        <SelectCustomizable
          options={classOptions}
          value={selectedClass}
          onChange={(option: { label: string; value: string } | null) => option && setSelectedClass(option)}
          placeholder={t('chatbot:ai_analytics_select_class')}
          size="default"
          variant="default"
        />
      </div>
      <div className="analytics-filter-bar__filter">
        <SelectCustomizable
          options={timePeriodOptions}
          value={selectedTimePeriod}
          onChange={(option: { label: string; value: string } | null) => option && setSelectedTimePeriod(option)}
          placeholder={t('chatbot:ai_analytics_select_period')}
          size="default"
          variant="default"
        />
      </div>
    </div>
  );
}

export default AnalyticsFilterBar;
